'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodes = exports.node = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var node = exports.node = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);

var nodes = exports.nodes = _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);


//////////////////
// WEBPACK FOOTER
// ./src/utils/prop-types.js
// module id = 127
// module chunks = 1